import { Controller } from "stimulus"
import { isNativeApp, postToNative } from "../lib/native_bridge"

// Ticket 136: in de native app opent de scan-knop de native camera-scanner via
// de bridge (betrouwbaarder op een gedeelde tablet); in de browser volgt de knop
// gewoon de link naar de web-scanner.
// Vervolg 1735: met automatisch opent de scanner direct bij het laden, zodat de
// tablet na Tablet vrijgeven zonder extra tik klaarstaat voor de volgende sporter.
export default class extends Controller {
  static values = { automatisch: Boolean }

  connect() {
    if (this.automatischValue && isNativeApp()) postToNative("scanner", "open")
  }

  open(event) {
    if (isNativeApp()) {
      event.preventDefault()
      postToNative("scanner", "open")
    }
  }
}
